/* Copyright (c) 2020 CLOUDPILOTS Software & Consulting GmbH */

// import defaultTheme from '@cloudpilots/components/core/theme';
import { createMuiTheme } from '@material-ui/core/styles';
// import deepmerge from 'deepmerge';
import { useMemo } from 'react';
import makeTheme from '../theme';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useTheme = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  const theme = useMemo(() => {
    // const mergedThemes = deepmerge(defaultTheme, makeTheme(prefersDarkMode));
    const mergedThemes = makeTheme(prefersDarkMode);
    const muiTheme = createMuiTheme(mergedThemes);
    return muiTheme;
  }, [prefersDarkMode]);

  return theme;
};

export { useTheme as default };
